<template>
<div class="forum">
  <div class="forum-head">
    <div class="content">
      <input placeholder="请输入您的标题" v-model="data.title">
      <quill-editor
          v-model:content="data.content"
          contentType="html"
          :toolbar="toolbarOptions"
      />
      <div class="opr">
        <el-dropdown :hide-on-click="false"  trigger="click" >
          <button style="background: #0a7bf1">{{selected.name}}>></button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="selectForumType(forumType.t.specialityCode,'专业论坛')" >专业论坛</el-dropdown-item>
              <el-dropdown-item @click="selectForumType(forumType.t.gradeCode,'年级论坛')" >年级论坛</el-dropdown-item>
              <el-dropdown-item >
                <el-dropdown placement="right-start" :hide-on-click="false"  trigger="click" >
                  课程论坛
                  <template #dropdown>
                    <el-dropdown-menu >
                      <el-dropdown-item  @click="selectForumType(key,name)" v-for="(name,key) in forumType.course">{{name}}</el-dropdown-item>
                      <el-dropdown-item >
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>

              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <button @click="submit">发布</button>
      </div>
    </div>
  </div>
  <div class="p" style="margin:40px 0">
    <div class="list">
      <div class="head">
        <span></span>专业论坛
        <button @click="showMore('00')" style="float: right">查看更多>></button>
      </div>
      <div class="content grid" >
        <div :index="key" v-for="(data,key) in proInfo" class="item" @click="toInfo(data.id)">
          <div class="title">
            <img :src="data.photo"><span>{{data.title}}</span>
          </div>
          <div class="person">{{data.content}}</div>
          <div class="foot">
            <img :src="data.newestUser[0]">
            <img style="    margin-left: -10px" :src="data.newestUser[1]">
            <span>{{data.count_amount}}人谈论中</span>
          </div>
        </div>
      </div>
    </div>
    <div class="list ">
      <div class="head">
        <span></span>年级论坛
        <button @click="showMore('10')" style="float: right">查看更多>></button>
      </div>
      <div class="content grid" >
        <div :index="key" v-for="(data,key) in gradeInfo" class="item">
          <div class="title">
            <img :src="data.photo"><span>{{data.title}}</span>
          </div>
          <div class="g-content">
            <div class="person">{{data.content}}</div>
            <div class="foot">
              <img :src="data.newestUser[0]">
              <img style="    margin-left: -10px" :src="data.newestUser[1]">
              <span>{{data.count_amount}}人谈论中</span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="list ">
      <div class="head">
        <span></span>课程论坛
        <button @click="showMore('20')">查看更多>></button>
      </div>
      <div class="content grid" >
        <div :index="key" v-for="(data,key) in courseInfo" class="item">
          <div  class="title">
            <img :src="data.photo"><span>{{data.title}}</span>
          </div>
          <div class="g-content">
            <div class="person">{{data.content}}</div>
            <div class="foot">
              <img :src="data.newestUser[0]">
              <img style="    margin-left: -10px" :src="data.newestUser[1]">
              <span>{{data.count_amount}}人谈论中</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</div>
</template>

<script setup>
import router from "@/router/index";
import { QuillEditor } from '@vueup/vue-quill'
import Footer from '@/component/footer'
import {getForumAreaBykeyCode, getForumAreaCourse, getForumAreaGradeAndSpecialty, insertForumPost} from "@/api/forum";
import {ref} from "vue";
let proInfo=ref();
let courseInfo=ref();
let gradeInfo=ref();
getForumAreaBykeyCode({type:"00"}).then(res => {
  proInfo.value=res.datas.data;
})
getForumAreaBykeyCode({type:"10"}).then(res => {
  gradeInfo.value=res.datas.data;
})
getForumAreaBykeyCode({type:"20"}).then(res => {
  courseInfo.value=res.datas.data;
})


const showMore =(code)=>{
  router.push(`/Forum/More?code=${code}`)
}

const toolbarOptions = ['bold', 'italic', 'underline','image']
let data=ref({
  title:'',
  content:'',
  area_id:'',
})
let forumType=ref({})

const selected=ref({
  code:"0",
  name:"论坛选择"
})
getForumAreaGradeAndSpecialty().then((rep)=>{
  forumType.value.t=rep.datas
})
getForumAreaCourse().then((rep)=>{
    forumType.value.course=rep.datas
})
const selectForumType=(code,name)=>{
  selected.value.name=name;
  data.value.area_id=code;
}
const toInfo =(id)=>{
  router.push({
    path:"/Forum/Info",
    query:{
      id:id
    }
  })
}
const submit= ()=>{
  if(selected.value.name=="论坛选择"){
    alert("请先选择发布的类型");
    return
  }
  insertForumPost(data.value).then((rep) =>{

  })

}

</script>


<style scoped>
.el-main{
  margin-right: 0 !important;
  margin-left: 0 !important;
}
</style>
<style lang="scss">

.forum{
  .p{
    .list:nth-child(2){
      .grid{
          grid-template-rows: repeat(4, 120px);
      }
      .item:nth-child(2),.item:nth-child(3){
        grid-area: span 1/span 4;
        .g-content{
          width: 100%;
          display: flex;
          .foot{
            position: relative;
            width: 150px;
            color: red;
          }
          .person{
            flex: 1;
          }
        }
      }
    }
    .list:nth-child(3){
      .item:nth-child(3),.item:nth-child(1){
        grid-area: span 1/span 4;
        .g-content{
          width: 100%;
          display: flex;
          .foot{
            position: relative;
            width: 150px;
            color: red;
          }
          .person{
            flex: 1;
          }
        }
      }
      .grid{
        grid-template-rows: repeat(4, 120px);
      }
    }
    .list{
      .head{
        width: 1200px;
        margin: 20px auto;
        line-height: 50px;
        font-weight: 900;
        button{
          cursor: pointer;
          float: right;
          margin-top: 15px;
          border: none;
          padding: 2px 16px;
          border-radius: 22px;
        }
        span{
          display: inline-block;
          height: 15px;
          width: 6px;
          background: red;
          margin: 0 10px;
          border-radius: 10px;
          vertical-align: middle;
        }
      }
      .content{
        .item{
          grid-area: span 2 / span 2 / auto / auto;
          position: relative;
          background: white;
          padding: 10px;
          &:hover{
            cursor: pointer;
            box-shadow: var(--el-box-shadow-light);
          }
          .person{
            font-size: 14px;
          }
          .person{
            line-height: 25px;
            color: silver;
          }
          .title{
            height: 40px;
            margin-bottom: 10px;
            img{
              height: 40px;
              width: 40px;
              border-radius: 4px;
              display: inline-block;
              vertical-align: middle;
            }
            span{
              font-size: 18px;
              font-weight: 500;
              margin-left: 10px;
            }
          }
          .foot{
            height: 30px;
            position: absolute;
            bottom: 0;
            margin-bottom: 16px;
            span{
              color: silver;
              font-size: 14px;
              margin-left:10px;
            }
            img:last-child{
              margin-left: -20px;
            }
            img{
              border: white solid 2px;
              vertical-align: middle;
              border-radius: 30px;
              height: 30px;
              width: 30px;
              display: inline-block;
            }

          }
        }
      }
    }
  }
  .content{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    &.grid{
      display: grid;
      grid-template-columns: repeat(6, 180px);
      grid-template-rows: repeat(4, 100px);
      grid-gap: 25px;
    }
  }

  .forum-head{
    height: auto;
    width: 100%;
    background-image:url('../../assets/bg.jpg');
    background-repeat: no-repeat;
    background-size:cover;
    .content {
      height: 360px;

    }
    textarea,input{
      width: 100%;
      border: none;
      outline: none;
      margin-bottom: 10px;

    }
    input{
      margin-top: 20px;
      height: 30px;
    }
    textarea{
      min-height: 200px;
    }
    .opr{
      bottom: 15px;
      position: absolute;
      right: 0;
      button{
        font-size: 12px;
        color: white;
        border: none;
        margin-left: 10px;
        padding: 5px 40px;
      }
      button:first-child{
        background: #f85d01;
      }
      button:last-child{
        background: #f85d01;
      }

    }
  }
}
</style>
<style>
.ql-toolbar.ql-snow{
  background: white;
}
.ql-container.ql-snow{
  height: 200px;
  background: white;
}
</style>
